import { PasswordField } from '../PasswordField';
import { RemovePasskeyField } from '../RemovePasskeyField';
import { TOTPField } from '../TOTPField';
import { UsernameField } from '../UsernameField';
import { WebField } from '../WebField';

export const PasswordFields = () => (
    <>
        <WebField />
        <UsernameField />
        <PasswordField />
        <TOTPField />
        <RemovePasskeyField />
    </>
);
